import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center px-4">
      <h1 className="text-6xl font-display font-bold text-primary mb-4">404</h1>
      <p className="text-xl text-dark-600 mb-8 font-body text-center">
        Oops! This page seems to have wandered off to the video store.
      </p>
      <Link
        to="/"
        className="rounded-lg bg-primary px-6 py-3 text-white font-medium hover:bg-primary-700 transition-colors"
      >
        Go Home
      </Link>
    </div>
  );
}
